//
// Copyright 2026 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/halo/inbox.proto (package dxos.halo.inbox, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Chain } from "./credentials_pb.js";
import { file_dxos_halo_credentials } from "./credentials_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/halo/inbox.proto.
 */
export const file_dxos_halo_inbox: GenFile = /*@__PURE__*/
  fileDesc("ChVkeG9zL2hhbG8vaW5ib3gucHJvdG8SD2R4b3MuaGFsby5pbmJveCKlAQoNSW5ib3hFbnZlbG9wZRIPCgd2ZXJzaW9uGBAgASgNEg4KBmhlYWRlchgRIAEoDBIkCgZzaWduZXIYEiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EhEKCXNpZ25hdHVyZRgTIAEoDBIwCgVjaGFpbhgUIAEoCzIcLmR4b3MuaGFsby5jcmVkZW50aWFscy5DaGFpbkgAiAEBQggKBl9jaGFpbiLBAQoTSW5ib3hFbnZlbG9wZUhlYWRlchIPCgd2ZXJzaW9uGAEgASgNEgwKBHR5cGUYAiABKAkSJAoGc2VuZGVyGAMgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRInCglyZWNpcGllbnQYBCABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EisKB3NlbnRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB3BheWxvYWQYBiABKAlCMFouZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvaGFsby9pbmJveGIGcHJvdG8z", [file_google_protobuf_timestamp, file_dxos_halo_credentials, file_dxos_keys]);

/**
 * Field numbers start past every `Credential` field, so a legacy credential payload decodes as an
 * envelope with no fields set (and vice versa) instead of being misread.
 *
 * @generated from message dxos.halo.inbox.InboxEnvelope
 */
export type InboxEnvelope = Message<"dxos.halo.inbox.InboxEnvelope"> & {
  /**
   * / Format version; a recipient leaves envelopes of a version it does not know pending.
   *
   * @generated from field: uint32 version = 16;
   */
  version: number;

  /**
   * / Binary `InboxEnvelopeHeader`; signed exactly as transmitted, so it is never re-encoded to verify.
   *
   * @generated from field: bytes header = 17;
   */
  header: Uint8Array;

  /**
   * / Key that made `signature`: the sender's identity key, or a device key `chain` delegates to it.
   *
   * @generated from field: dxos.keys.PublicKey signer = 18;
   */
  signer?: PublicKey;

  /**
   * @generated from field: bytes signature = 19;
   */
  signature: Uint8Array;

  /**
   * / The device's `AuthorizedDevice` credential, present when `signer` is not the sender identity.
   *
   * @generated from field: optional dxos.halo.credentials.Chain chain = 20;
   */
  chain?: Chain;
};

/**
 * Describes the message dxos.halo.inbox.InboxEnvelope.
 * Use `create(InboxEnvelopeSchema)` to create a new message.
 */
export const InboxEnvelopeSchema: GenMessage<InboxEnvelope> = /*@__PURE__*/
  messageDesc(file_dxos_halo_inbox, 0);

/**
 * @generated from message dxos.halo.inbox.InboxEnvelopeHeader
 */
export type InboxEnvelopeHeader = Message<"dxos.halo.inbox.InboxEnvelopeHeader"> & {
  /**
   * / Repeats the envelope version under the signature.
   *
   * @generated from field: uint32 version = 1;
   */
  version: number;

  /**
   * / Reverse-DNS payload type (e.g., `org.dxos.inbox.message`).
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * / Sender identity key.
   *
   * @generated from field: dxos.keys.PublicKey sender = 3;
   */
  sender?: PublicKey;

  /**
   * / Recipient identity key.
   *
   * @generated from field: dxos.keys.PublicKey recipient = 4;
   */
  recipient?: PublicKey;

  /**
   * @generated from field: google.protobuf.Timestamp sent_at = 5;
   */
  sentAt?: Timestamp;

  /**
   * / Type-specific payload (e.g., a JSON-encoded message).
   *
   * @generated from field: string payload = 6;
   */
  payload: string;
};

/**
 * Describes the message dxos.halo.inbox.InboxEnvelopeHeader.
 * Use `create(InboxEnvelopeHeaderSchema)` to create a new message.
 */
export const InboxEnvelopeHeaderSchema: GenMessage<InboxEnvelopeHeader> = /*@__PURE__*/
  messageDesc(file_dxos_halo_inbox, 1);

